var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinNUnpin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8513 4.45766C12.2847 3.89107 9.04138 0.647797 8.54233 0.148745C8.344 -0.0495815 8.02246 -0.0495815 7.82416 0.148745C7.62586 0.347071 7.62586 0.668592 7.82416 0.866893L8.18326 1.22599L5.48454 3.92471C4.81108 3.79138 4.11205 3.81066 3.44567 3.98278C2.65907 4.18595 1.93813 4.5985 1.3608 5.17586C1.16247 5.37416 1.1625 5.69568 1.3608 5.89401L3.87434 8.40755L0.148726 12.1331C-0.0495752 12.3314 -0.0495752 12.653 0.148726 12.8513C0.347026 13.0496 0.668573 13.0496 0.866899 12.8513L4.59246 9.1257L7.10598 11.6392C7.20516 11.7384 7.33508 11.788 7.46508 11.788C7.59503 11.788 7.72501 11.7384 7.82418 11.6392C8.40149 11.0619 8.81406 10.3409 9.01724 9.55434C9.18936 8.88797 9.20863 8.18896 9.0753 7.51548L11.774 4.81673L12.1331 5.17581C12.3314 5.37411 12.6529 5.37413 12.8513 5.17581C13.0496 4.97751 13.0496 4.65599 12.8513 4.45766ZM8.15804 6.99644C8.02987 7.12461 7.97975 7.31141 8.02649 7.48653C8.30912 8.54481 8.08367 9.67195 7.43911 10.536L4.95167 8.04855L4.95159 8.04845C4.95159 8.04845 4.95154 8.0484 4.95149 8.04838L2.46402 5.56091C3.32809 4.91634 4.45525 4.69092 5.51348 4.97352C5.6886 5.02029 5.8754 4.97017 6.0036 4.84197L8.90143 1.94412L11.0559 4.09856L8.15804 6.99644Z",
    fill: "#A1A1AA",
    stroke: "#A1A1AA",
    strokeWidth: 1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinNUnpin);
export default __webpack_public_path__ + "static/media/pin_n_unpin.c528babef8ab4353a26b94b1515c50c9.svg";
export { ForwardRef as ReactComponent };